var map = {
	"./adv.png": 73,
	"./avatar.svg": 28,
	"./azymuth.jpg": 74,
	"./bfj.gif": 75,
	"./falafel.gif": 76,
	"./festival.gif": 77,
	"./hfc.gif": 78,
	"./memorygame.jpg": 79,
	"./quiz.jpg": 80,
	"./trawill.gif": 81
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;